// frontend/src/components/Map.js
import React from 'react';

function Map() {
    return (
        <div className="t117">
            <div className="t-width t-margin_auto t-width_100">
                {/* Карта */}
                <iframe
                    title="Трайтек на карте Саратова"
                    src="https://yandex.ru/map-widget/v1/?ll=46.001347%2C51.556452&mode=search&oid=1069206182&ol=biz&z=16"
                    width="100%"
                    height="385"
                    frameBorder="0"
                    allowFullScreen
                    style={{ border: 0 }}
                ></iframe>

                {/* Подпись под картой */}
                <div style={{ marginTop: '8px', fontSize: '12px', textAlign: 'center', color: '#666' }}>
                    <a
                        href="https://yandex.ru/maps/org/traytek/1069206182/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#666', textDecoration: 'none' }}
                    >
                        Трайтек на Яндекс.Картах
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Map;